import type { RegistrantAccountUserResponseSchema } from "@/hera-api/client/types.gen";
import { UserPortalToggles } from "./user-portal-toggles";

interface RegistrantUserAccessControlsProps {
  user: RegistrantAccountUserResponseSchema;
  primaryAccountId?: string;
  idPrefix?: string;
  disabled?: boolean;
  onUserChange?: (user: RegistrantAccountUserResponseSchema) => void;
}

export function RegistrantUserPortalControls({
  user,
  primaryAccountId,
  idPrefix = "details-",
  disabled = false,
  onUserChange,
}: RegistrantUserAccessControlsProps) {
  const rowLocked = disabled || user.status === "disabled";

  return (
    <UserPortalToggles
      row={user}
      primaryAccountId={primaryAccountId}
      idPrefix={idPrefix}
      fullLabels
      disabled={rowLocked}
      onRowChange={onUserChange}
    />
  );
}
